import Layout from '@layout/Index'

export const userCredit = [
  {
    path: '/user-credit',
    component: Layout,
    children: [
      {
        path: 'update/:userid',
        component: () => import(/* webpackChunkName: "user-credit-form" */ './pages/UserCreditForm.vue'),
        name: '修改用户赏金',
        meta: {
          title: '修改用户赏金',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/user-credit/user-credit.route.js